export default __webpack_public_path__ + "static/media/KhopshefProvince.48d49ce6.jpg";